import { Typography } from "@mui/material"
import { toPercent } from "plugins/toolbox/constants.js"

export function QuickWinMatch({ item }) {
    const closeness = `${toPercent(item.closeness)}`

    return (
        <Typography variant="caption" component="div">
            {item.match} — {item.stats} ({closeness})
        </Typography>
    )
}
